export enum PropertyTypes {
  'INTEGER' = 'integer',
  'STRING' = 'string',
  'DOUBLE' = 'double',
  'LONG' = 'long',
  'PASSWORD' = 'password',
  'BOOLEAN' = 'boolean',
  'URL' = 'url',
}

export const WITH_OUT_TITLE_KEY = 'withOutTitle';

export enum TABS {
  INTEGRATION = 'Интеграция',
  MAIL = 'Почта',
}

// Порядок ключей и элементов массива отвечает за отображение порядка на ui
export const GROUP_MEMBERSHIP_SORTING = {
  [TABS.INTEGRATION]: ['Настройка Apache NiFi', 'ETL процесс', WITH_OUT_TITLE_KEY],
  [TABS.MAIL]: ['Почтовый сервис', WITH_OUT_TITLE_KEY],
};

export enum MailKeys {
  host = 'mail.host',
  port = 'mail.port',
  username = 'mail.username',
  password = 'mail.password',
  authEnable = 'mail.smtp.auth',
  starttlsEnable = 'mail.smtp.starttls.enable',
  sslEnable = 'mail.smtp.ssl.enable',
  senderName = 'email.sender.name',
  url = 'mail.url',
  transportProtocol = 'mail.transport.protocol',
}

// *.checkbox - чексбоксы которые добавляются только на фронте
export enum CheckboxWithRelatedFields {
  mail = 'mail.checkbox',
}

export const ALL_CHECKBOX_RELATED_FIELDS = {
  [CheckboxWithRelatedFields.mail]: Object.values(MailKeys),
};

export const CUSTOM_CHECKBOX = {
  mail: {
    label: 'Использовать почтовый сервис',
    relatedFieldsKeys: ALL_CHECKBOX_RELATED_FIELDS[CheckboxWithRelatedFields.mail],
    key: CheckboxWithRelatedFields.mail,
  },
};

export const EMPTY_PASSWORD_TYPE_VALUE = '**********';
